import { pmt } from './excel.js';
import { MONTHS_PER_YEAR, TIMELINE_YEARS, at, zeros } from './series.js';
export function buildLoanSchedule(params) {
    const { principal, annualRate, years, mode } = params;
    const schedule = {
        mode,
        monthlyPayment: 0,
        bop: zeros(),
        interest: zeros(),
        payment: zeros(),
        principalRepaid: zeros(),
        eop: zeros(),
    };
    schedule.eop[0] = principal;
    // Sans dette ou sans durée, il n'y a rien à amortir : le classeur produit des zéros.
    if (!(principal > 0) || !(years > 0))
        return schedule;
    return mode === 'annual-excel'
        ? buildAnnualExcel(schedule, principal, annualRate, years)
        : buildMonthlyExact(schedule, principal, annualRate, years);
}
function buildAnnualExcel(schedule, principal, annualRate, years) {
    // F56 = PMT(taux ; années ; dette) / 12, puis H161 = F56 * 12 * drapeau.
    // On garde le « / 12 puis * 12 » : il n'est pas neutre en virgule flottante.
    const monthly = -pmt(annualRate, years, principal) / MONTHS_PER_YEAR;
    schedule.monthlyPayment = monthly;
    for (let n = 1; n <= TIMELINE_YEARS; n++) {
        const active = n <= years ? 1 : 0;
        const bop = at(schedule.eop, n - 1);
        schedule.bop[n] = bop;
        schedule.interest[n] = bop * annualRate * active;
        schedule.payment[n] = monthly * MONTHS_PER_YEAR * active;
        schedule.principalRepaid[n] = at(schedule.payment, n) - at(schedule.interest, n);
        schedule.eop[n] = bop - at(schedule.principalRepaid, n);
    }
    return schedule;
}
function buildMonthlyExact(schedule, principal, annualRate, years) {
    const monthlyRate = annualRate / MONTHS_PER_YEAR;
    const monthly = -pmt(monthlyRate, years * MONTHS_PER_YEAR, principal);
    schedule.monthlyPayment = monthly;
    let balance = principal;
    for (let n = 1; n <= TIMELINE_YEARS; n++) {
        schedule.bop[n] = balance;
        if (n <= years) {
            for (let month = 0; month < MONTHS_PER_YEAR; month++) {
                const interest = balance * monthlyRate;
                const principalPart = monthly - interest;
                balance -= principalPart;
                schedule.interest[n] = at(schedule.interest, n) + interest;
                schedule.principalRepaid[n] = at(schedule.principalRepaid, n) + principalPart;
                schedule.payment[n] = at(schedule.payment, n) + monthly;
            }
        }
        schedule.eop[n] = balance;
    }
    return schedule;
}
//# sourceMappingURL=loan.js.map